import React from "react";
import * as constants from "../../../../EventSettings/constants";
import { defaultFirstScreenSubtitle } from "../../../constants/loginAndRegistrationPage";
import HideSetting from "../HideSetting";
import TextSetting from "../TextSetting";

const ScreenEmailRequest = ({moduleSettings, guest, authRequire, hasRegistrationFields, onUpdate}) => {
    return (
        <>
            {
                (authRequire) &&
                <HideSetting
                    eventSetting={moduleSettings}
                    title="Только вход"
                    name={constants.SETTINGS_ENTER_ONLY}
                    value={moduleSettings[constants.SETTINGS_ENTER_ONLY]}
                    onUpdate={onUpdate}
                />
            }
            <TextSetting
                eventSetting={moduleSettings}
                title="Подзаголовок"
                property={constants.SETTINGS_LOGIN_SUBTITLE}
                defaultText={defaultFirstScreenSubtitle(guest, authRequire, hasRegistrationFields, moduleSettings?.enterOnly)}
                toggleProperty={constants.SETTINGS_HIDE_LOGIN_SUBTITLE}
                rows={6}
                onUpdate={onUpdate}
            />
        </>
    );
};

export default ScreenEmailRequest;
